// Trilingual dictionary: EN | ID | JA
export const LANGUAGES = [
  { code: "en", label: "EN", name: "English" },
  { code: "id", label: "ID", name: "Bahasa Indonesia" },
  { code: "ja", label: "JP", name: "日本語" },
];

export const dict = {
  brand_short: { en: "IJFF 2026", id: "IJFF 2026", ja: "IJFF 2026" },
  brand: {
    en: "Indonesia Japan Friendship Festival 2026",
    id: "Festival Persahabatan Indonesia Jepang 2026",
    ja: "インドネシア・日本友好フェスティバル 2026",
  },
  nav_home: { en: "Home", id: "Beranda", ja: "ホーム" },
  nav_map: { en: "Booth Map", id: "Peta Booth", ja: "会場マップ" },
  nav_booths: { en: "Booth Info", id: "Info Booth", ja: "ブース案内" },
  nav_gallery: { en: "Gallery", id: "Galeri", ja: "ギャラリー" },
  nav_sponsors: { en: "Sponsors", id: "Sponsor", ja: "スポンサー" },
  nav_register: { en: "Register", id: "Daftar", ja: "登録" },
  nav_dashboard: { en: "My Dashboard", id: "Dasbor Saya", ja: "マイページ" },
  login: { en: "Sign in with Google", id: "Masuk dengan Google", ja: "Googleでログイン" },
  logout: { en: "Sign out", id: "Keluar", ja: "ログアウト" },
  hero_kicker: {
    en: "12 – 13 December 2026 · Shiokaze Park, Odaiba Tokyo",
    id: "12 – 13 Desember 2026 · Taman Shiokaze, Odaiba Tokyo",
    ja: "2026年12月12日〜13日 · 潮風公園（お台場・東京）",
  },
  hero_title_1: { en: "Two Cultures.", id: "Dua Budaya.", ja: "二つの文化。" },
  hero_title_2: { en: "One Friendship.", id: "Satu Persahabatan.", ja: "一つの友情。" },
  hero_sub: {
    en: "Music · Cuisine · Cosplay · Business Matching · Speech Contest · Stamp Rally",
    id: "Musik · Kuliner · Cosplay · Business Matching · Kontes Pidato · Stamp Rally",
    ja: "音楽・料理・コスプレ・ビジネスマッチング・スピーチコンテスト・スタンプラリー",
  },
  cta_register: { en: "Join / Register", id: "Gabung / Daftar", ja: "参加登録" },
  cta_map: { en: "View Booth Map", id: "Lihat Peta Booth", ja: "会場マップを見る" },
  countdown_days: { en: "Days", id: "Hari", ja: "日" },
  countdown_hours: { en: "Hours", id: "Jam", ja: "時" },
  countdown_min: { en: "Minutes", id: "Menit", ja: "分" },
  countdown_sec: { en: "Seconds", id: "Detik", ja: "秒" },
  concept_title: { en: "Festival Concept", id: "Konsep Festival", ja: "フェスティバルコンセプト" },
  concept_body: {
    en: "Indonesia and Japan have shared a friendship for over 68 years. IJFF 2026 brings together arts, cuisine, business, and community — a celebration of trust, culture, and shared future.",
    id: "Indonesia dan Jepang telah menjalin persahabatan selama lebih dari 68 tahun. IJFF 2026 menyatukan seni, kuliner, bisnis, dan komunitas — perayaan kepercayaan, budaya, dan masa depan bersama.",
    ja: "インドネシアと日本は68年以上にわたる友好関係を築いてきました。IJFF 2026は、芸術・料理・ビジネス・コミュニティが融合する、信頼と文化と未来への祝祭です。",
  },
  programs_title: { en: "Festival Programs", id: "Program Festival", ja: "フェスティバルプログラム" },
  prog_music: { en: "Music & Arts", id: "Musik & Seni", ja: "音楽・芸術" },
  prog_cuisine: { en: "Authentic Cuisine", id: "Kuliner Autentik", ja: "本場の料理" },
  prog_cosplay: { en: "Cosplay Show", id: "Pertunjukan Cosplay", ja: "コスプレショー" },
  prog_speech: { en: "Speech Contest", id: "Kontes Pidato", ja: "スピーチコンテスト" },
  prog_bm: { en: "Business Matching", id: "Business Matching", ja: "ビジネスマッチング" },
  prog_stamp: { en: "Stamp Rally", id: "Stamp Rally", ja: "スタンプラリー" },
  coming_soon: { en: "Coming Soon", id: "Segera Hadir", ja: "近日公開" },
  map_title: { en: "Venue & Booth Layout", id: "Denah Lokasi & Booth", ja: "会場・ブース配置図" },
  map_sub: {
    en: "127 booths across 12 zones, plus stage and amenities.",
    id: "127 booth dalam 12 zona, termasuk panggung dan fasilitas.",
    ja: "12ゾーンにわたる127ブース、ステージと共用設備を含む。",
  },
  booths_title: { en: "Booth Types & Pricing", id: "Tipe Booth & Harga", ja: "ブースタイプ・料金" },
  sponsors_title: { en: "Sponsor With Us", id: "Jadi Sponsor", ja: "スポンサーになる" },
  register_title: { en: "Choose Your Registration", id: "Pilih Jenis Registrasi", ja: "登録カテゴリを選択" },
  reg_performer: { en: "Stage Performer", id: "Penampil Panggung", ja: "ステージ出演者" },
  reg_restaurant: { en: "Restaurant / Catering", id: "Restoran / Katering", ja: "飲食・ケータリング" },
  reg_trader: { en: "Trader / Services / Local Gov.", id: "Pedagang / Jasa / Pemda", ja: "物販・サービス・自治体" },
  reg_bm: { en: "Business Matching", id: "Business Matching", ja: "ビジネスマッチング" },
  reg_sponsor: { en: "Sponsor", id: "Sponsor", ja: "スポンサー" },
  reg_speech: { en: "Speech Contest (Info)", id: "Kontes Pidato (Info)", ja: "スピーチコンテスト（案内）" },
  reg_stamp: { en: "Stamp Rally (Info)", id: "Stamp Rally (Info)", ja: "スタンプラリー（案内）" },
  submit: { en: "Submit Registration", id: "Kirim Pendaftaran", ja: "登録する" },
  next: { en: "Next", id: "Lanjut", ja: "次へ" },
  back: { en: "Back", id: "Kembali", ja: "戻る" },
  terms_agree: {
    en: "I have read and agree to the Terms & Conditions, including the deposit policy.",
    id: "Saya telah membaca dan menyetujui Syarat & Ketentuan, termasuk kebijakan deposit.",
    ja: "利用規約およびデポジット規定を読み、同意します。",
  },
  privacy_note: {
    en: "Your data is private — only the organizer and you can view your registration.",
    id: "Data Anda bersifat pribadi — hanya panitia dan Anda yang dapat melihat pendaftaran.",
    ja: "データは非公開です。主催者と本人のみ閲覧可能です。",
  },
  login_required: {
    en: "Please sign in with Google to access this page.",
    id: "Silakan masuk dengan Google untuk mengakses halaman ini.",
    ja: "Googleでログインしてください。",
  },
  deadline: { en: "Application deadline: 31 August 2026", id: "Batas pendaftaran: 31 Agustus 2026", ja: "申込締切：2026年8月31日" },
};

export const t = (key, lang) => {
  const entry = dict[key];
  if (!entry) return key;
  return entry[lang] || entry.en || key;
};
